import { Box, Button, Card, CardBody, CardHeader, Heading, HStack, Spacer, Stack, StackDivider, Text, useDisclosure } from '@chakra-ui/react';
import React, {useRef, useState} from 'react';
import {useAuth} from '../../../auth/AuthProvider';
import { EditIcon } from '@chakra-ui/icons';
import EditModal from '../../parts/EditModal';
import InputEmail from '../../parts/InputEmail';
import InputRequiredRef from '../../../interfaces/InputRef';
import InputPassword from '../../parts/InputPassword';
import EditModalProps from '../../../interfaces/EditModalProps';
import RequiredMark from '../../parts/RequiredMark';
import { InstructorTranslateKey } from '../../../utils/instructorTranslateKey';
import { Instructor } from '../../../model/instructor';
import { useApiProvider } from "../../../api/ApiProvider";

const PersonalProfile: React.FC = () => {

  const userAuth = useAuth();
  const provider = useApiProvider();

  const emailRef = useRef<InputRequiredRef>();

  const { isOpen, onOpen, onClose } = useDisclosure();

  const [modalContext, setModalContent] = useState<EditModalProps | undefined>(undefined);

  const [submittingError, setSubmittingError] = useState<string>("");
  const [submitting, setSubmitting] = useState<boolean>(false);
  
  return (
    <Box
      display="flex"
      alignItems="start"
      justifyContent="center"
      height="100%"
      width="100%"
      pt="89px"
    >
      <Card
        display="flex"
        justifyContent="center"
        alignItems="center"
        shadow="none"
        padding="10"
        width="100%"
        maxWidth="500px"
      >
        <CardHeader>
          <Heading size='md'>Dane osobowe</Heading>
        </CardHeader>

        <CardBody
          width="100%"
        >
          {userAuth.user ? (
            <Stack divider={<StackDivider />} spacing='4'>
              {Object.entries(userAuth.user)
                .filter(([key,]) => !(['Id', 'PhoneNumber', 'InstructorRole', 'Gender'].includes(key)))
                .map(([key, value]) => (
                  <Box key={key}>
                    {value ? (
                      <Heading size='xs' textTransform='uppercase'>
                        {InstructorTranslateKey[key]}
                      </Heading>
                    ) : (
                      <></>
                    )}
                    <HStack>
                      {value ? (
                        <Text pt='2' fontSize='sm'>
                          {typeof value === "string" ? (!isNaN((new Date(value)).getTime()) ? value.split("T")[0] : value) : value}
                        </Text>
                      ) : (
                        <></>
                      )}
                      <Spacer />
                    </HStack>
                  </Box>
                ))}

            </Stack>
          ) : (
            <Text pt='2' fontSize='sm' textTransform='uppercase'>
              brak danych
            </Text>
          )}
        </CardBody>
      </Card>

      {modalContext && (
        <EditModal
          isOpen={isOpen}
          isSubmitting={submitting}
          submittingError={submittingError}
          onClose={onClose}
          title={modalContext.title}
          content={modalContext.child}
          onConfirm={modalContext.onConfirm}
        />
      )}
    </Box>
  );
};

export default PersonalProfile;

function authUser(arg0: Instructor) {
  throw new Error('Function not implemented.');
}
